import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Socials } from './social.model';
import { environment } from './../../environments/environment';

@Injectable()
export class SocialService {

  constructor(private httpClient: HttpClient) {}

  items(query: any): Observable<Socials> {
    const params = new HttpParams({fromObject: query});
    params['front'] = true;
    return this.httpClient.get<Socials>(environment.api + '/facebook', { params: params });
  }

}

